<template>
  <div class="col-12 bg-white rounded-lg pb-0">
  <div v-if="dataLoading" class="row align-items-center ">
    <div class="col-12 text-center">
      <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
  </div>
  <div v-else-if="products.length > 0 && products !== undefined" class="row">
    <h1 class="col-8 primary-text py-0">{{ title }}</h1>
     <div class="col-12 pb-0" dir="ltr">
    <carousel
        v-if="products.length >0"
        :autoplay="false"
        :autoplayTimeout="7000"
        :dots="false"
        :margin="15"
        :items="1"
        :nav="true"
        :navText="navText"
        :rtl="true"
        class="owl-carousel-post-card">
      <div v-for="item in products" :key="item.id" class="col-12 py-0">
        <product-lists-card :item="item"/>
      </div>
    </carousel>


</div>
  </div>
</div>
</template>

<script>
import carousel from "vue-owl-carousel";
import ProductListsCard from "@/components/ProductListsCard";

export default {
  name: "ProductListCardCarousel",
  components: {ProductListsCard,carousel},
  props:['title','products','dataLoading'],
  data: () => ({
    navText: ['<i class="fa-solid fa-circle-chevron-left" aria-hidden="true"></i>'],
  }),

}
</script>

<style scoped>

</style>
